import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { DEPARTMENTS } from "@/lib/deptContent";

function Edit() {
  const { id } = Route.useParams();
  return <DeptContentForm cfg={DEPARTMENTS} id={id} />;
}

export const Route = createFileRoute("/_app/structure/departments/$id")({
  component: Edit,
});
